export const productsStyles = {
  wrapper: {
    maxWidth: "82.5rem",
    my: {
      mobile: "6rem",
    },
    mx: {
      tablet: "2.5rem",
    },
  },
  grid: {
    maxWidth: "90rem",
    px: {
      mobile: "1.5rem",
      tablet: "unset",
    },
    alignItems: "left",
    justifyContent: "center",
    margin: {
      tablet: "auto 0",
      laptop: "auto",
    },
  },
};
